import { Rectangle, SkeletonContainer } from 'src/app/pages/starterDashboardV2/shared/components';

export function SocialContentPreviewLoading() {
	return (
		<SkeletonContainer
			loading
			className="bg-icon-inverse-disabled flex h-[170px] w-[131px] flex-col items-center justify-center rounded-lg p-[14px]"
		>
			<div className="bg-background-base flex h-full w-full flex-col items-start justify-start rounded p-[2px]">
				<Rectangle className="h-[50%] w-full rounded-sm" />
			</div>
		</SkeletonContainer>
	);
}
